import { KIND } from 'baseui/button'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import {
  meterSearchButtonOverrides,
  pulseMeterSearchButtonOverrides,
  pulseModalButtonOverrides,
  pulseResultsTableOverrides,
  resultsTableOverrides,
} from './styled-components'

const useMeterSearchStyles = () => {
  const isPulse = usePulseScope()

  return {
    isPulse,
    openButtonKind: isPulse ? KIND.secondary : undefined,
    openButtonOverrides: isPulse ? pulseMeterSearchButtonOverrides : meterSearchButtonOverrides,
    chooseButtonKind: isPulse ? KIND.secondary : KIND.primary,
    backButtonKind: isPulse ? KIND.secondary : undefined,
    backButtonOverrides: isPulse ? pulseModalButtonOverrides : undefined,
    backIconSize: isPulse ? 18 : 24,
    headerIconSize: isPulse ? 18 : 21,
    tableOverrides: isPulse ? pulseResultsTableOverrides : resultsTableOverrides,
  }
}

export default useMeterSearchStyles
